export class Qualifier {

    name: string;
    code: string;

    constructor(qualifier: IQualifier) {
        this.name = qualifier.name;
        this.code = qualifier.code;
    }
}

export interface IQualifier {

    name: string;
    code: string;
}